






















































import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { teacherModule } from '@/store/modules/entities/teacher.module';
import { GEnum } from '@/constants/enum.defination';
import { GPageBase } from '@/mixins';
import * as XLSX from 'xlsx';
import GImportModal from '@/components/GImportModal.vue';
import { importModalModule } from '@/store/modules/frames/import-modal.module';

@Component({
  name: 'GTeachersImport',
  components: { GImportModal },
  computed: {},
  methods: {},
})
export default class GTeachersImport extends Mixins(GPageBase) {
  showTeacherImportModal: boolean = false;
  showConfirmModal: boolean = false;
  entryCount: number = 0;

  @Prop() value: boolean;

  @Watch('value')
  openModal(value: boolean) {
    this.showTeacherImportModal = value;
  }

  @Watch('showTeacherImportModal')
  close(value: boolean) {
    this.$emit('input', value);
  }
  mounted() {}

  handleTeacherTemplateDownload() {
    teacherModule.downloadRegistrationTeacher().then(() => {
      importModalModule.setIsDownloading(false);
    });
  }

  handleTeacherUpload(workBook: XLSX.WorkBook) {
    this.entryCount = XLSX.utils.sheet_to_json(workBook.Sheets['先生']).length;
    this.showConfirmModal = true;
  }

  handleOK(formData: FormData) {
    teacherModule
      .postTeachersExcel(formData)
      .then((response: any) => {
        this.showConfirmModal = false;
        if (response) {
          this.showNotice(GEnum.MessageType.Success, this.$t('NOTICE.MESSAGE.NEW_TEACHER').toString(), '', 3);
          this.$emit('input', false);
          this.lazyAction(() => {
            window.location.reload();
          }, 5000);
        }
      })
      .finally(() => {
        importModalModule.setIsUploading(false);
      });
  }
}
